import { render, staticRenderFns } from "./dispatchStatis.vue?vue&type=template&id=abfc46c2&scoped=true&"
import script from "./dispatchStatis.vue?vue&type=script&lang=js&"
export * from "./dispatchStatis.vue?vue&type=script&lang=js&"
import style0 from "./dispatchStatis.vue?vue&type=style&index=0&id=abfc46c2&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abfc46c2",
  null
  
)

export default component.exports